module.exports = __webpack_public_path__ + "img/DSC00188.7a196bf4.JPG";